import React from 'react'
import PropTypes from 'prop-types'
import Documents from './Documents'
import { SERVICE_HOME_SECURE } from '../constants'
import ServiceDetails from './ServiceDetails'

const HomeSecureDetailsAndDocs = (props) => {
    return (
        <div>
            <ServiceDetails title='My service details' details={props.serviceDetails.data} />
            <Documents title='My documents' type={SERVICE_HOME_SECURE} serviceId={props.serviceId} />
        </div>
    )
}

HomeSecureDetailsAndDocs.propTypes = {
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.object.isRequired
}

export default HomeSecureDetailsAndDocs



// WEBPACK FOOTER //
// ./resources/js/modules/HomeSecureDetailsAndDocs.js